export default __webpack_public_path__ + "static/media/outline.6c09a369.svg";